import {IInvent, IInventedItems, IPosition, TransformTopResult} from '../../entities/reports';
import {defaultInventCategory} from '../const';

export const transformTopPositions = (
	inventedGroupsData: IInventedItems[],
	data: IPosition[],
	shop_id: number,
): TransformTopResult => {
	const updatedData: (IPosition & IInvent)[] = data.map((item: IPosition) => {
		const catcode: number = item.CATCODE;
		const foundInvent = inventedGroupsData.find(
			(inventItem: IInventedItems) => inventItem.category_id === catcode,
		);

		return {
			...item,
			...(foundInvent ? foundInvent.invent : defaultInventCategory(shop_id)),
		};
	});

	const inventedCategoriesNameArray = Array.from(
		new Set(updatedData.map((i) => i.name_invented)),
	).map((o) => ({
		text: o,
		value: o,
	}));

	const categoriesNameArray = Array.from(
		new Set(updatedData.map((i) => i.CATEGORY || 'Без категории')),
	)
		.filter(Boolean)
		.map((o) => ({
			text: o,
			value: o,
		}));

	return {
		updatedData,
		inventedCategoriesNameArray,
		categoriesNameArray,
	};
};
